define('any.roles',['require','exports','module','underscore','fukit/fukit'],function(require, exports, module) {
  //prettier-ignore
  var _      = require('underscore'),
      config = require('fukit/fukit').config;

  //prettier-ignore
  var RoleKeyPrefixes        = config.get('ROLE_KEY_PREFIXES'),
      RoleValuePrefixes      = config.get('ROLE_VALUE_PREFIXES'),
      RolePermissionSuffixes = config.get('ROLE_PERMISSION_SUFFIXES'),
      AnyRoles               = {};

  _.each(RoleKeyPrefixes, function(keyPrefix, index) {
    var anyRoleKey = 'ANY_' + keyPrefix + 'ROLE';
    AnyRoles[anyRoleKey] = [];

    _.each(RolePermissionSuffixes, function(permissionSuffix) {
      var roleKey = keyPrefix + permissionSuffix,
        roleValue = RoleValuePrefixes[index] + permissionSuffix;

      if (permissionSuffix !== 'BULK_LOAD' && permissionSuffix !== 'BULK_DELETE' && permissionSuffix !== 'PURGE') {
        AnyRoles[anyRoleKey].push(roleValue);
      }
    });
  });

  module.exports = AnyRoles;
});

